import { DefaultFooter } from '@ant-design/pro-components';
import React from 'react';

const Footer: React.FC = () => {
  return (
    <DefaultFooter
      style={{
        background: 'none',
      }}
      copyright="YYPAGE管理平台 © 2024-2026"
      links={[]}
    />
  );
};

export default Footer;
